import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66ae3e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page contact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Contact")
], -1))
const _hoisted_3 = { class: "contact-links" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "contact-text" }
const _hoisted_7 = ["href", "textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ContactOptions, (contact, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            title: contact.name,
            class: "contact-link"
          }, [
            _createElementVNode("img", {
              class: "contact-icon",
              src: `/images/social-icons/${contact.icon}.svg`,
              alt: contact.name
            }, null, 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("a", {
                target: "_blank",
                href: contact.link,
                textContent: _toDisplayString(contact.name)
              }, null, 8, _hoisted_7)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}